import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(
  ({ typography, palette, spacing, breakpoints }) => ({
    title: {
      fontWeight: typography.fontWeightBold,
      color: palette.grey.shade[100],
      marginBottom: spacing(5)
    },
    create: {
      marginLeft: 'auto'
    },
    actions: {
      [breakpoints.down('sm')]: {
        marginBottom: spacing(3)
      }
    },
    filterBar: {
      marginBottom: spacing(3)
    },
    pagination: {
      marginTop: spacing(3),
      marginBottom: spacing(3)
    }
  })
)
